import { createAction, props } from '@ngrx/store';

import { IParamsPremiadosToken, IResultSectionsPremiados, IResultTokenPremiados } from '../../shared/models/ProgramClose';

/*
 * Obtiene token de consulta premiados
 */
export const getTokenPremiados = createAction(
    '[TokenPremiados] token premiados',
    props<IParamsPremiadosToken>()
);

export const successTokenPremiados = createAction(
    '[TokenPremiados] Success token premiados',
    props<IResultTokenPremiados>()
);

export const errorTokenPremiados = createAction(
    '[TokenPremiados] Error token premiados',
    props<{ payload: Error }>()
);

export const clearTokenPremiados = createAction('[TokenPremiados] Clear token premiados');

/*
 * Obtiene las secciones de premiados
 */
export const getSeccionesPremiados = createAction(
    '[SeccionesPremiados] Secciones premiados',
    props<IParamsPremiadosToken>()
);

export const successSeccionesPremiados = createAction(
    '[SeccionesPremiados] Success Secciones premiados',
    props<IResultSectionsPremiados>()
);

export const errorSeccionesPremiados = createAction(
    '[SeccionesPremiados] Error Secciones premiados',
    props<{ payload: Error }>()
);

export const clearSeccionesPremiados = createAction('[SeccionesPremiados] Clear Secciones premiados');
